import { connect } from 'react-redux';
import { compose } from 'redux';
import { Dispatch } from 'redux-api-middleware';
import { submitForm } from 'store/api/submitForm/submitForm';
import { ResetPasswordResponse } from 'store/api/types';
import { resetPassword } from 'store/api/user/userActions';

import { ResetPassword } from './ResetPassword';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onResetPassword: submitForm<ResetPasswordResponse>(dispatch, resetPassword),
});

export const ResetPasswordContainer = compose(
  connect(
    undefined,
    mapDispatchToProps,
  ),
)(ResetPassword);
